import { Box, Button, Card, CardMedia, Grid2, IconButton, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import * as React from 'react';
import { useApi } from '../Api/useApi';
import { ProjectDto, ProjectsRycApiClient } from '../Api/ApiServer';
import CreateProjectDialog from './CreateProjectDialog';
import { AccountCircle, AddCircleOutline, Block, Delete, InfoOutlined, QuestionMark, Share, SignalCellularNodata } from '@mui/icons-material';
import { useNavigate } from 'react-router';
import SearchBox from '../Shared/SearchBox';
import DeleteDialog from '../Shared/DeleteDialog';
import ProjectUsersDialog from './Components/ProjectUsersDialog';

export interface IProjectListProps {
}

export default function ProjectList(props: IProjectListProps) {
  const { authorizedApi } = useApi(ProjectsRycApiClient);
  const theme = useTheme();
  const biggerThan500 = useMediaQuery(theme.breakpoints.up(500));
  const [projects, setProjects] = React.useState<ProjectDto[]>([]);
  const [visibleProjects, setVisibleProjects] = React.useState<ProjectDto[]>([]);
  const [creating, setCreating] = React.useState(false);
  const [deletingProject, setDeletingProject] = React.useState<ProjectDto | null>(null);
  const navigate = useNavigate();
  const refresh = React.useCallback(async () => {
    const projectsApi = await authorizedApi?.projectsList();
    setProjects(projectsApi?.projects ?? []);

  }, [authorizedApi]);
  React.useEffect(() => {
    refresh();
  }, [refresh]);
  React.useEffect(() => {
    setVisibleProjects(projects);
  }, [projects]);
  const [selectedProjectUsers, setSelectedProjectUsers] = React.useState<ProjectDto | null>(null);
  return (
    <Box display='flex' width={'100vw'} flexDirection='column'>
      <CreateProjectDialog open={creating} onClose={(refreshData, id) => { if (id) navigate(id.toString() + '/detail') }} />
      <DeleteDialog open={deletingProject !== null}
        onClose={() => setDeletingProject(null)}
        data={deletingProject}
        onDeleteAgree={(data) => {
          if (data.id) {
            authorizedApi?.deleteProject(data.id).then(() => {
              setDeletingProject(null);
              refresh();
            })

          }


        }} />
      <ProjectUsersDialog
        onClose={() => { setSelectedProjectUsers(null) }}
        open={selectedProjectUsers !== null}
        projectId={selectedProjectUsers?.id} />
      <Box p={2} display='flex' justifyContent={'space-between'} alignItems='center'>
        {biggerThan500 && <Typography variant='h5' color='primary'>PROJEKTY</Typography>}
        <Stack direction={'row'} alignItems={'end'} spacing={2} /* ml={2} */>
          <Button variant='contained' size='small' startIcon={<AddCircleOutline />} onClick={() => setCreating(true)}>přidat</Button>
          <SearchBox label='Hledat projekt' size='small' items={projects} onSearchChange={(_, projects) => { setVisibleProjects(projects) }} propsToSearch={['name', 'partnerName']} />
        </Stack>
      </Box>
      <Grid2 width={'100%'} height={'calc(100vh - 124px)'} p={2} overflow={'auto'} spacing={2} container>
        {visibleProjects.map((project) => (
          <Grid2 key={project.id} size={{ sm: 12, md: 6, lg: 4, xl: 4, xs: 12 }}>
            <Card sx={{
              height: 360,

              minWidth: '100%',
              width: '100%',
              cursor: 'pointer',
              transition: 'box-shadow 0.3s',
              '&:hover': {
                boxShadow: 6
              }
            }} onClick={() => { console.log('click', project.id); if (project.id) navigate(project.id.toString() + '/detail') }} key={project.id}>
              {project.imageUri && <CardMedia
                component="img"
                height="200"
                width={'100%'}
                image={project.imageUri}
                alt={project.name}
              >



              </CardMedia>}
              {!project.imageUri && <Box
                // component="ico"
                // component={'div'}
                pt={8}
                sx={{ height: 200, width: '100%',  }}
              // height="200"
              // width={'100%'}

              // image={ }
              // alt={project.name}
              >
                <InfoOutlined sx={{fontSize: '48px'}} />
                <Typography variant='h5'>Není vybrán obrázek</Typography>

              </Box>}
              <Box px={3} py={1} textAlign={'left'} mt={2} key={project.id} display='flex' flexDirection='column' justifyContent='space-between' height='140px'>
                <Box>
                  <Typography variant='h6'>{project.name}</Typography>
                  <Typography variant='body2' sx={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical'
                  }}>{project.description}</Typography>
                </Box>
                <Box display='flex' justifyContent={'space-between'}>
                  <Button variant='outlined' onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    setSelectedProjectUsers(project);
                  }} startIcon={<AccountCircle />}>Uživatelé</Button>
                  <Box>
                    <IconButton onClick={(e) => { e.stopPropagation(); e.preventDefault(); setDeletingProject(project); }}><Delete /></IconButton>
                    <IconButton color='primary'><Share /></IconButton>
                  </Box>
                </Box>
              </Box>

            </Card>
          </Grid2>
        ))}
      </Grid2>
    </Box>
  );
}
